<template>
  <div class="container">
    <div class="col-lg-12 col-md-12 mx-auto mt-4"><h2 class="fw-light">Aktywacja konta</h2></div>
    <hr class="my-4">
    <div v-if="isLoading" class="alert alert-info">
      <span class="spinner-border spinner-border-sm me-2"></span> Trwa aktywacja Twojego konta...
    </div>
    <div v-if="!isLoading && !error" class="alert alert-success"><font-awesome-icon icon="fa-check"/> Twoje konto zostało aktywowane! Możesz teraz korzystać z systemu rezerwacji online!</div>
    <div v-if="!isLoading && error" class="alert alert-danger"><font-awesome-icon icon="fa-x"/> {{ this.error }}</div>
  </div>
</template>

<script>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {fetchWrapper} from "@/wrappers/api/fetchWrapper";
// import {fetchWrapper} from "@/wrappers/api/fetchWrapper";

export default {
  name: "PrivacyPolicyPage",
  components: {FontAwesomeIcon},
  data() {
    return {
      isLoading: true,
      error: null,
      token: this.$route.query.token,
      email: this.$route.query.email,
    }
  },
  methods: {
    async activateAccount() {
      if (!this.token || !this.email) {
        this.isLoading = false;
        this.error = "Niepoprawny link aktywacyjny!";
      }


      try {
        const body = {
          token: this.token,
          email: this.email,
        };

        this.response = await fetchWrapper.post(`/user/activate`, body)

        this.response.status === 200 ? this.error = null : this.error = this.response.response;
      } catch (err) {
        this.error = "Niepoprawny link aktywacyjny!";
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.activateAccount();
  }
}
</script>

<style scoped>

</style>